/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1PersonIdAttachmentsAttachmentid200,
  GetApiV1PersonIdAttachmentsAttachmentid401,
  GetApiV1PersonIdAttachmentsAttachmentid404,
  GetApiV1PersonIdAttachmentsAttachmentid500,
  GetApiV1PersonIdAttachmentsAttachmentidPathParams,
  GetApiV1PersonIdAttachmentsAttachmentidQueryResponse,
} from "../../types/personDocumentsController/GetApiV1PersonIdAttachmentsAttachmentid.ts";
import { personAttachmentDetailViewModelSchema } from "../personAttachmentDetailViewModelSchema.ts";

export const getApiV1PersonIdAttachmentsAttachmentidPathParamsSchema = z.object(
  {
    id: z.coerce.number().int(),
    attachmentId: z.coerce.number().int(),
  },
) as unknown as ToZod<GetApiV1PersonIdAttachmentsAttachmentidPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1PersonIdAttachmentsAttachmentid200Schema = z.lazy(
  () => personAttachmentDetailViewModelSchema,
) as unknown as ToZod<GetApiV1PersonIdAttachmentsAttachmentid200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1PersonIdAttachmentsAttachmentid401Schema =
  z.any() as unknown as ToZod<GetApiV1PersonIdAttachmentsAttachmentid401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1PersonIdAttachmentsAttachmentid404Schema =
  z.any() as unknown as ToZod<GetApiV1PersonIdAttachmentsAttachmentid404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1PersonIdAttachmentsAttachmentid500Schema =
  z.any() as unknown as ToZod<GetApiV1PersonIdAttachmentsAttachmentid500>;

export const getApiV1PersonIdAttachmentsAttachmentidQueryResponseSchema =
  z.lazy(
    () => getApiV1PersonIdAttachmentsAttachmentid200Schema,
  ) as unknown as ToZod<GetApiV1PersonIdAttachmentsAttachmentidQueryResponse>;
